// extracted by mini-css-extract-plugin
export default {"section":"FiltersContent_section__Rt10S"};